module.exports = __webpack_public_path__ + "img/05_thisisengineering.acc9ac45.jpg";